/**
 * Track Edit Form
 * 
 * @Author: Focci
 * @Date: 2023-08-17 21:33:28
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 21:33:28
 */

import PropTypes from 'prop-types'
import StyledInput from '@comp/form/StyledInput'
import useMessage from '@hook/useMessage'
import { map } from 'lodash-es'
import { initialImages } from '@comp/upload/lib'
import { fetchPost, fetchProxy } from '@lib/fetch/client'
import { Button } from '@comp/material'
import { useCallback, useState } from 'react'
import { useTranslations } from 'next-intl'
import TrackUploadImage from './TrackUploadImage'
import EstimateInfo from '../../EstimateInfo'

function TrackEditFormItem({ label, value, setter }) {
  return (
    <div>
      <div className="whitespace-nowrap text-f.8 mb-1">
        {label}
      </div>
      <StyledInput
        value={value}
        variant="outline"
        onChange={(e) => setter(e.target.value)}
      />
    </div>
  )
}

export default function TrackEditForm({
  propertyId,
  param = {},
  property = {},
  onSuccess = () => {},
}) {
  const tt = useTranslations('track')
  const th = useTranslations('house')
  const { message } = useMessage()
  
  const td = property?.track_data || {}
  const agree = td.is_agree_estimate === undefined ? true : td.is_agree_estimate
  
  const [agreeEstimate] = useState(agree)
  const [bathrooms, setBathrooms] = useState(td.bathrooms)
  const [bedrooms, setBedrooms] = useState(td.bedrooms)
  const [floorArea, setFloorArea] = useState(td.floor_area)
  const [landArea, setLandArea] = useState(td.land_area)
  const [estimateValue] = useState(td.estimate_value)
  const [propertyImages, setPropertyImages] = useState(initialImages(td.property_images))
  const [estimateReport] = useState(initialImages([td.estimate_report]))
  const [loading, setLoading] = useState(false)

  const handlePropertyFinish = useCallback((v) => setPropertyImages(v), [])
  // const handleEstimateFinish = useCallback((v) => setEstimateReport(v), [])

  // 提交数据
  const handleSubmit = useCallback(async () => {
    const newParam = { 
      bathrooms, bedrooms, floorArea, landArea, estimateValue 
    }
    
    newParam.agreeEstimate = agreeEstimate ? 1 : 0
    newParam.propertyImages = map(propertyImages, 'url').join(',')
    newParam.estimateReport = map(estimateReport, 'url').join(',')

    fetchProxy(
      fetchPost(`property-edit/${propertyId}`, newParam),
      setLoading
    ).then(() => {
      onSuccess({ 
        newParam: param, 
        nextStep: 'editSuccess' 
      })
    }).catch((err) => message(err.message))
  }, [
    agreeEstimate, bathrooms, bedrooms, estimateReport, estimateValue, 
    floorArea, landArea, message, onSuccess, param, propertyId, propertyImages
  ])

  return (
    <div className="my-8 flex flex-col gap-y-4 w-[30rem] mx-auto max-w-full">
      <div>
        <div className="whitespace-nowrap text-f.8 mb-1">
          {tt('propertyImages')}
          {`(${tt('uploadImageLimit')})`}
        </div>
        <TrackUploadImage
          value={propertyImages}
          onFinish={handlePropertyFinish} 
        />
      </div>
      <TrackEditFormItem 
        label={th('bedroomCount')}
        value={bedrooms}
        setter={setBedrooms}
      />
      <TrackEditFormItem 
        label={th('bathroomCount')}
        value={bathrooms}
        setter={setBathrooms}
      />
      <TrackEditFormItem 
        label={`${th('landArea')}(m2)`}
        value={landArea}
        setter={setLandArea}
      />
      <TrackEditFormItem 
        label={`${th('buildingArea')}(m2)`}
        value={floorArea}
        setter={setFloorArea}
      />
      <div className="border px-6 pb-6">
        <div className="my-4 font-medium text-f.9 text-center">
          {th('hgEstimate')}
        </div>
        <EstimateInfo data={property.avm} />
      </div>
      {/* <div className="flex items-center justify-between">
        <span className="text-f.8">{tt('agreeValuation')}</span>
        <Switch 
          checked={agreeEstimate}
          onChange={(e) => setAgreeEstimate(e.target.checked)}
        />
      </div>
      {!agreeEstimate && (
        <>
          <Divider className="my-4" />
          <TrackEditFormItem
            label={tt('typeEstimate')}
            value={estimateValue}
            setter={setEstimateValue}
          />
          <div>
            <div className="whitespace-nowrap text-f.8 mb-1">
              {tt('uploadEstimateReport')}
              <span className="text-meta">
                {`(${tt('uploadEstimateReportNote')})`}
              </span>
            </div>
            <TrackUploadImage
              multiple={false}
              value={estimateReport}
              onFinish={handleEstimateFinish} 
            />
          </div>
        </>
      )} */}
      
      <div className="mt-6 flex items-center justify-center gap-4">
        <Button 
          size="large" 
          color="primary" 
          disabled={loading}
          onClick={handleSubmit}
        >
          <span className="px-10 text-f.8">
            {loading ? 'Loading...' : tt('confirmSubmit')}
          </span>
        </Button>
      </div>
    </div>
  )
}

TrackEditForm.propTypes = {
  propertyId: PropTypes.number,
  param: PropTypes.object,
  property: PropTypes.object,
  onSuccess: PropTypes.func,
}
